import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ExamHeader from "../components/exam/ExamHeader";
import QuestionPanel from "../components/exam/QuestionPanel";
import ExamSubmittedAlready from "../components/exam/ExamSubmittedAlready";
import { maxios } from "../store/maxios";
import ExamCompleted from "../components/exam/ExamCompleted";
import { Navigate } from "react-router";

function ExamPage() {

  const exam = useSelector((state)=>state.auth.exam);
  const [saving,setSaving]=useState(false);
  useEffect(() => {
    const handleVisiblitychnage = () => {
      if(exam.window_restricted==1){
      if (document.hidden) {
       tabSubmitExam()
      }
    }
    };

    const handleKeyPress = (event) => {
      // alert("you ", event);
    };

    document.addEventListener("keydown", handleKeyPress);

    document.addEventListener("visibilitychange", handleVisiblitychnage);

    return () => {
      document.removeEventListener("visibilitychange", handleVisiblitychnage);
    };
  }, []);

  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [examFinished, setExamFinished] = useState(false);
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });
  const data = useSelector((state) => state.auth.data); 
  const totalQuestions = data.questions.length;

  useEffect(() => {
    const attempts = JSON.parse(localStorage.getItem("attempts")) || [];
    attempts.push(data.questions[currentQuestion].code);
    localStorage.setItem("attempts", JSON.stringify(attempts));
  }, [currentQuestion]);

  useEffect(() => {
    const updateTimer = () => {
      
      const now = new Date();
      const examTime = new Date(data.exam?.exam_date);
      let diff = Math.floor((examTime - now) / 1000) + parseInt(exam.allotted_time);
      if (diff <= 0) {
        // tabSubmitExam();
        if (localStorage.getItem("submitted") === "1") tabSubmitExam();
        setExamFinished(true);
        return;
      }
      setTimeLeft({
        days: Math.floor(diff / 86400),
        hours: Math.floor((diff % 86400) / 3600),
        minutes: Math.floor((diff % 3600) / 60),
        seconds: diff % 60,
      });
    };

    updateTimer();
    const interval = setInterval(updateTimer, 1000);
    return () => clearInterval(interval);
  }, [data]);

  const totalAnswered = data.questions.reduce(
    (count, q) => (localStorage.getItem(q.code) ? count + 1 : count),
    0
  );
  
  const tabSubmitExam = async () => {
      try{
        const answers = Object.fromEntries(
          Object.entries(localStorage).map(([key, val]) => [key, val])
        );
        const res = await maxios.post("/submit-exam", {
          answers: JSON.stringify(answers),
          questions: JSON.stringify(Object.keys(answers)),
        });
        if (res.data.response) {
          localStorage.setItem("submitted", "0");
          window.location.href = "/home/exam";
        } else {
          alert(res.data.message);
        }
      } catch (err) {
        console.error("Submission error:", err);
        alert("Error submitting exam.");
      }
    
  };

  const submitExam = async () => {
    
    if (navigator.onLine) {
      if (!window.confirm("Are you sure you want to submit the exam?")) return;
      try {
        const answers = Object.fromEntries(
          Object.entries(localStorage).map(([key, val]) => [key, val])
        );
        const res = await maxios.post("/submit-exam", {
          answers: JSON.stringify(answers),
          questions: JSON.stringify(Object.keys(answers)),
        });
        if (res.data.response) {
          localStorage.setItem("submitted", "0");
          window.location.href = "/home/exam";
        } else {
          alert(res.data.message);
        }
      } catch (err) {
        console.error("Submission error:", err);
        alert("Error submitting exam.");
      }
    } else {
      // alert("NET NAHI HAI");
    }
  };

const saveAndNext = async () => {
    try {
      setSaving(true)
      if (navigator.onLine) {
        const lastSelection = localStorage.getItem("lastSelection");
        if (!lastSelection) {
          return setCurrentQuestion((q) => Math.min(q + 1, totalQuestions - 1));
        }

        const res = await maxios.post("/save-answer", {
          question_code: data.questions[currentQuestion].code,
          selected: lastSelection,
        });

        if (res.data?.response) {
          const prev = JSON.parse(localStorage.getItem("answereds") || "[]");
          const updated = [
            ...new Set([...prev, data.questions[currentQuestion].code]),
          ];
          localStorage.setItem("answereds", JSON.stringify(updated));
          localStorage.removeItem("lastSelection");
          setCurrentQuestion((q) => Math.min(q + 1, totalQuestions - 1));
        } else {
          alert(res.data?.message || "Something went wrong while saving answer.");
        }
      } else {
        alert("No Internet, please connect to the network");
      }
    } catch (error) {
      console.error("Error in saveAndNext:", error);
      alert("An error occurred. Please try again.");
    }finally{
      setSaving(false);
    }
};


  const handleClear = async () => {
    if (navigator.onLine) {
      const qCode = data.questions[currentQuestion].code;
      localStorage.removeItem("lastSelection");
      localStorage.removeItem(qCode);
      const res = await maxios.post("/save-answer", {
        question_code: qCode,
        selected: "",
      });
      if (!res.data.response) alert(res.data.message);
    } else {
      alert("NET NAHI HAI");
    }
  };


  if (!data.questions.length) return (window.location.href = "/");
  if (examFinished) return <Navigate to={"/home/exam-completed" }/> ;
  if (data.attempts > 0) return <Navigate to={"/home/exam/exam-submitted"}/>;



  return (
    <div className="exam-page">
      <ExamHeader
        timer={`${timeLeft.hours.toString().padStart(2, "0")}:${timeLeft.minutes
          .toString()
          .padStart(2, "0")}:${timeLeft.seconds.toString().padStart(2, "0")}`}
      />
      <div className="section-toggle">
        Online Exam
        <button className="toggle-button" onClick={() => setCurrentQuestion(0)}>
          Section A
        </button>
        <button
          className="toggle-button"
          onClick={() => setCurrentQuestion(20)}
        >
          Section B
        </button>
        {/* <button
          className="toggle-button"
          onClick={() => setCurrentQuestion(40)}
        >
          Maths
        </button> */}
      </div>

      <div className="exam-content">
        <QuestionPanel
        saving = {saving}
        setSaving={setSaving}
          index={currentQuestion}
          question={data.questions[currentQuestion]}
          saveAndNextQuestion={saveAndNext}
          submitPaper={submitExam}
          next={() =>
            setCurrentQuestion((q) => Math.min(q + 1, totalQuestions - 1))
          }
          prev={navigator.onLine ?() => setCurrentQuestion((q) => Math.max(q - 1, 0)): ("")}
          clear={handleClear}
        />

        <div className="side-panel">
          <div className="status-panel">
            <div className="status-summary">
              <div className="status-item">
                <span className="not-answered">{data.questions.length - totalAnswered}</span> Not
                Answered
              </div>
              <div className="status-item">
                <span className="answered">{totalAnswered}</span> Answered
              </div>
            </div>

            <div className="question-grid">
              {data.questions.map((q, i) => {
                const attempts =
                  JSON.parse(localStorage.getItem("attempts")) || [];
                const answereds = JSON.parse(
                  localStorage.getItem("answereds") || "[]"
                );

                const isAnswered = localStorage.getItem(q.code);
                return (
                  <button
                    key={i}
                    className={`toggle-button question-button ${
                      currentQuestion === i ? "current" : ""
                    } ${
                      answereds.includes(q.code)
                        ? "answer-green"
                        : isAnswered
                        ? "answer-blue"
                        : attempts.includes(q.code)
                        ? "answer-orange"
                        : "white"
                    }`}
                    onClick={() => setCurrentQuestion(i)}
                  >
                    {i + 1}
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ExamPage;
